export default [
  {
    path: '/activity-anniversary2024/index',
    name: 'index',
    component: () => import('@/views/activity-anniversary2024/index'),
    meta: {
      title: '2024周年庆典，狂欢生日趴，赢多重惊喜礼-高考直通车'
    }
  },
  {
    path: '/activity-anniversary2024/components/giftaddress',
    name: 'giftaddress',
    component: () => import('@/views/activity-anniversary2024/components/giftaddress'),
    meta: {
      title: '2024周年庆典，狂欢生日趴，赢多重惊喜礼-高考直通车'
    }
  },
  {
    path: '/activity-anniversary2024/components/giftList',
    name: 'giftList',
    component: () => import('@/views/activity-anniversary2024/components/giftList'),
    meta: {
      title: '2024周年庆典，狂欢生日趴，赢多重惊喜礼-高考直通车'
    }
  },
]
